namespace Areas.Account.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Account", "Edit",
        ["Profile","AccountStatusReport", "Workflows", "CIB", "PWC", "Milestones", "Schedule", "Team", "Module", "ContractsSummary", "FinanceFunding", "Report"]);

    let summaryTabItems = Areas.createTabsWithSameAction("Account", "Edit",
        ["ContractsSummary", "InspectionsSummary", "GLSummary", "GLDetailSummary", "RechargeSummary", "YearMonthChart", "YearMonthGLChart"]);

    let financeTabItems = Areas.createTabsWithSameAction("Account", "Edit",
        ["FinanceValidFund", "FinanceRechargeJob", "FinanceFunding"]); 

    let reportTabItems = Areas.createTabsWithSameAction("Account", "Edit",
        ["Report1", "Report2"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function summaryTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(summaryTabItems)(params);
    }

    export function financeTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(financeTabItems)(params);
    }

    export function reportTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(reportTabItems)(params);
    }


    export function updateAccount() {
        const form = $("#AccountForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Account/Profile/Put/${keyId}`,
                JSON.stringify(newData),
                "PUT");
        }
    }



    export function returnToListFromTab() {
        var linkInfo = "/Account/List/Active";
        location.href = linkInfo;

    }


}
